import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import ViewObservationFormTableCellButton from "../ViewObservationFormTableCellButton/ViewObservationFormTableCellButton";

export interface StoreObservationTableCellProps {
	cellValue?: TableCellValue;
	showStatistics: boolean;
	storeId?: number;
	regionId?: number;
	areaId?: number;
}

const StoreObservationTableCell: FC<StoreObservationTableCellProps> = ({
	cellValue,
	storeId,
	showStatistics
}) => {
	const { control, setValue } = useFormContext<ReportDetailForm>();

	const { showObservationsPassedThresholdReport } = useWatch({
		control,
		name: "filters"
	});

	const handleObservationSuccessButtonClick = () => {
		if (!cellValue || !cellValue.month) return;

		setValue("filters.storeId", storeId);
		setValue("filters.month", cellValue.month);
	};

	if (!cellValue || cellValue.month === null) {
		return <span className="text-zinc-300">&mdash;</span>;
	}

	const { complete, passedThreshold } = cellValue;

	if (showStatistics && showObservationsPassedThresholdReport) {
		return <span>{passedThreshold}</span>;
	}

	if (showStatistics && !showObservationsPassedThresholdReport) {
		return <span>{complete}</span>;
	}

	if (showObservationsPassedThresholdReport && !passedThreshold) {
		return (
			<ViewObservationFormTableCellButton
				completed={false}
				showIcon={true}
				onClick={storeId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={passedThreshold}
			/>
		);
	}

	return (
		<ViewObservationFormTableCellButton
			completed={true}
			showIcon={true}
			onClick={storeId ? handleObservationSuccessButtonClick : undefined}
			totalNumObservations={complete}
		/>
	);
};

export default StoreObservationTableCell;
